"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pimDocumentFragment = void 0;
exports.pimDocumentFragment = `
fragment documentPreview on Document {
  id
  name
  components {
    id
    type
    content {
      ... on ImageContent {
        images {
          url
          bucketKey: key
          variants {
            width
            url
            bucketKey: key
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=document.js.map